import Check from "../Check.js";
import Resource from "../Resource.js";
import CesiumTerrainProvider, {
  TerrainProviderBuilder,
  requestLayerJson,
} from "../CesiumTerrainProvider";
import constantUrl from "../../../../widgets/Source/Ditap/icon/ConstantUrl.js";
import Credit from "../Credit.js";

/**
 * 
 * 다이탭 국내 지형 터레인 제공 클래스.</br>
 * Terrain providing class for accessing nation terrain data in DiTAP.
 *
 * @alias NationwideTerrainProvider
 * @constructor
 * 
 * @example
 * 

// DitapViewer 생성
const viewer = new Ditap.DitapViewer("ditapContainer", {
  baseLayerPicker: true,
});

// DitapBaseLayerPicker 인스턴스 생성
const ditapBaseLayerPicker = viewer.ditapBaseLayerPicker;

const ditapTerrainProvider = new Ditap.ProviderViewModel({
  name: "Ditap Korea Terrain",
  iconUrl: Ditap.Utils.getUrlFromBase64(
    Ditap.ConstantUrl.DITAP_TERRAIN_IMG_URL
  ),
  tooltip: "",
  category: "Ditap",
  creationFunction: () => {
    return Ditap.NationwideTerrainProvider.create();
  },
});

ditapBaseLayerPicker.viewModel.selectedTerrain = ditapTerrainProvider;

 * */
class NationwideTerrainProvider extends CesiumTerrainProvider {
  constructor(options) {
    super(options);
  }

  fromIonAssetId() {
    return;
  }
  fromUrl() {
    return;
  }
  getLevelMaximumGeometricError() {
    return;
  }
  getTileDataAvailable() {
    return;
  }
  loadTileDataAvailability() {
    return;
  }
  requestTileGeometry() {
    return;
  }
}

/**
 * Creating a TerrainProvider accessing nation terrain data in DITAP.<br>
 * 다이탭 전국 지형 데이터에 접근하는 TerrainProvider 생성.
 * @returns {Promise<CesiumTerrainProvider>} 전국 TerrainProvider. <br> Nation terrainProvider.
 */
NationwideTerrainProvider.create = async function () {
  // let url = "http://121.135.139.45:9092/tilesets/layer";
  let url = `${constantUrl.DITAP_TERRAIN_RESOURCE_BASE_URL}/tilesets/layer`;
  //>>includeStart('debug', pragmas.debug);
  Check.defined("url", url);
  //>>includeEnd('debug');

  const options = { credit: new Credit("© Heliosen Co., Ltd., CC-BY-ND") };

  url = await Promise.resolve(url);
  const resource = Resource.createIfNeeded(url);
  resource.appendForwardSlash();

  const terrainProviderBuilder = new TerrainProviderBuilder(options);
  terrainProviderBuilder.lastResource = resource;
  terrainProviderBuilder.layerJsonResource = terrainProviderBuilder.lastResource.getDerivedResource(
    {
      url: "layer.json",
    }
  );

  await requestLayerJson(terrainProviderBuilder);

  const provider = new CesiumTerrainProvider(options);
  terrainProviderBuilder.build(provider);

  return provider;
};
export default NationwideTerrainProvider;
